import { Record } from 'immutable';

const defaultValues = {
  price: 0,
  costMarginPercent: 0,
  cost: 0,
};

export default class MenuItemStandardCost extends Record(defaultValues, MenuItemStandardCost) {
  constructor(values) {
    super({
      ...values,
    });
  }

  calculateStandardCost() {
    return (this.price * (this.costMarginPercent / 100)).toFixed(2);
  }
}
